import Action from "./action";

/**
 * Action to add an item to the cart.
 * 
 * For an example config object, see TODO!
 */
class CartAddAction extends Action {
  type = "cart.add";
  dependencies = {
    execute: [],
    undo: [],
    hydrateMeta: ["idToGraphQlId", "executeGQL"]
  }

  /**
   * Constructor
   * @param {Object} config 
   */
  constructor(config = {}) {
    super(config);
    this.initialize();
  }

  /**
   * Override setter to add a property to the variant to ensure that the we can
   * identify this specific action to undo it if necessary.
   */
  set guid(value) {
    super.guid = value;

    // We need an Action-specific GUID so that, if multiple propositions attempt
    // to add the same variant to the cart, they don't get stuck in an infinite
    // loop of adding / removing the same item.
    this.config.variant.properties = { 
      ...(this.config.variant.properties || {}), "_r_add": value
    };
  }

  /**
   * Execute the action
   * @param {Object} data 
   */
  async execute(data) {
    this.log = [];
    console.groupCollapsed(this.logPrefix);
    console.log('Config', this.config);
    console.log('Data', data);

    // Check if our serialized variant is already in the cart by serializing each item in the cart and comparing
    let serializedVariant = JSON.stringify({ id: this.config.variant.id, properties: this.config.variant.properties });
    let existingCount = data.response.items.filter(item => {
      let serializedExistingLineItem = JSON.stringify({ id: item.id, properties: item.properties });
      return serializedExistingLineItem === serializedVariant
    });

    if (existingCount.length < (this.config.limit || 1)) {
      // @ts-ignore
      let result = await Stencil.Extensions.Cart.add(this.config.variant);
      console.log('Added!', result);
      this.addLog(result, "Added to cart");
    } else {
      console.log('Not adding as reached limit');
      this.addLog(null, "Reached limit", "⚠️");
    }
    console.groupEnd();
  }

  /**
   * Undo the action
   * @param {Object} data 
   */
  async undo(data) {
    this.log = [];
    console.groupCollapsed(this.logPrefix);
    let previouslyAddedLineItem = data.response.items.find(item => {
      return item.id == this.config.variant.id && JSON.stringify(item.properties) == JSON.stringify(this.config.variant.properties || {});
    });

    if (previouslyAddedLineItem) {
      console.log('Undoing', this.config);
      // @ts-ignore
      let result = await Stencil.Extensions.Cart.change({ id: previouslyAddedLineItem.key, quantity: 0 });
      this.addLog(result, "Removed previously added item", "", "undo");
    } else {
      console.log('Nothing to undo', this.config);
      this.addLog(null, "No matching item", "⚠️", "undo");
    }
    console.groupEnd();
  }

  explainAction() { 
    return `Add ${Stencil.Logger.variant({ title: this.meta[this.config.variant.id]?.title, id: this.config.variant.id })} from ${Stencil.Logger.product({ title: this.meta[this.config.variant.id]?.product.title, id: this.meta[this.config.variant.id]?.product.id.split("/").pop() })} to cart with properties ${Stencil.Logger.properties(this.config.variant.properties)}`;
  }

  explainUndo() {
    if(this.config.bidirectional){
      return `Remove ${Stencil.Logger.variant({ title: this.meta[this.config.variant.id]?.title, id: this.config.variant.id })} from ${Stencil.Logger.product({ title: this.meta[this.config.variant.id]?.product.title, id: this.meta[this.config.variant.id]?.product.id.split("/").pop() })} from cart where properties match ${Stencil.Logger.properties(this.config.variant.properties)}`;
    }
  }

  async hydrateMeta() {
    super.hydrateMeta();

    const graphQlIds = [Stencil.Helpers.idToGraphQlId(this.config.variant.id, "variant")];
    
    const result = await Stencil.Helpers.executeGQL(`{
      nodes(ids: ${JSON.stringify(graphQlIds)}) {
        ... on ProductVariant {
          id
          title
          product {
            id
            title
          }
        }
      }
    }`, {});
    
    result.data.nodes.forEach(node => {
      this.meta[node.id.split("/").pop()] = node;
    });
  }
}

export default CartAddAction;